import { render, staticRenderFns } from "./purchase-request-popup.vue?vue&type=template&id=4d79a496&scoped=true&"
import script from "./purchase-request-popup.vue?vue&type=script&lang=js&"
export * from "./purchase-request-popup.vue?vue&type=script&lang=js&"
import style0 from "./purchase-request-popup.vue?vue&type=style&index=0&id=4d79a496&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d79a496",
  null
  
)

export default component.exports